import { makeAutoObservable, runInAction } from 'mobx';
import { Confirm } from 'components/Dialog';
import { ReactNode } from 'react';

type SimpleDialogType = 'success' | 'error' | 'info';

interface DialogProps {
    type: SimpleDialogType;
    title: string;
    text: string;
    confirm?: Confirm;
    hideCancel?: boolean;
    onClose?(): void;
    hideAllButton?: boolean;
    icon?: ReactNode;
}

type ActionProps = Omit<DialogProps, 'type'>;

export class Dialog {
    isOpen: boolean = false;
    type: SimpleDialogType = 'info';
    title: string = '';
    text: string = '';
    confirm?: Confirm;
    hideCancel?: boolean = false;
    onClose?: () => void;
    hideAllButton?: boolean = false;
    icon: ReactNode = null;
    constructor() {
        makeAutoObservable<this>(this);
    }

    open = ({ type, title, text, icon, confirm, onClose, hideCancel, hideAllButton }: DialogProps) => {
        this.isOpen = true;
        this.type = type;
        this.title = title;
        this.confirm = confirm;
        this.text = text;
        this.onClose = onClose;
        this.hideCancel = hideCancel;
        this.hideAllButton = hideAllButton;
        this.icon = icon;
    };

    success = (props: ActionProps) => {
        this.open({
            type: 'success',
            ...props,
        });
    };

    error = (props: ActionProps) => {
        this.open({
            type: 'error',
            ...props,
        });
    };

    info = (props: ActionProps) => {
        this.open({
            type: 'info',
            ...props,
        });
    };

    close = () => {
        runInAction(() => {
            this.isOpen = false;
            // this.title = '';
            this.confirm = undefined;
            if (this.onClose) {
                this.onClose();
            }
            this.onClose = undefined;
            this.hideCancel = false;
            this.hideAllButton = false;
            this.icon = null;
        });
        // this.isOpen = false;
        // // this.title = '';
        // this.confirm = undefined;
        // if (this.onClose) {
        //     this.onClose();
        // }
        // this.onClose = undefined;
        // this.hideCancel = false;
        // this.hideAllButton = false;
        // this.text = '';
        // this.type = 'success';
    };
}

export default new Dialog();
